@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div class="one" fxLayout="column">
  <h3 style="margin-bottom: 0px; padding: 15px 15px 0 15px" class="text-[14px]">
    <b>Default Accounts tell the system what account to use in specific circumstances.</b>
    <br />
    <br />
    Most of these don't need to be changed unless you want a different account to be used for
    something.
  </h3>
  <br />
  <div class="border-line"></div>
  <br />
  <div [ngClass]="class == true ? 'example-containerdata-two' : 'example-containerdata'">
    <!-- <table mat-table [@animateStagger]="{value:'50'}" (matSortChange)="sortData($event)" matSortActive="{{sortactive}}" matSortDirection="{{sortDirection}}" matSortDisableClear [dataSource]="FinalList" matSort>
  <ng-container matColumnDef="DESCRIPTION">
    <mat-header-cell *matHeaderCellDef mat-sort-header mwlResizable

      (resizeEnd)="onResizeEnd($event, 'DESCRIPTION')"
      mwlResizeHandle
      [resizeEdges]="{ right: true }"
      >
      <div class="resize-handle-right" mwlResizeHandle
      [resizeEdges]="{ right: true }"></div>
    Description </mat-header-cell>
    <mat-cell *matCellDef="let element"> {{element.DESCRIPTION}} </mat-cell>
  </ng-container>
  <ng-container matColumnDef="ACCOUNTTYPE">
    <mat-header-cell *matHeaderCellDef mat-sort-header mwlResizable

      (resizeEnd)="onResizeEnd($event, 'ACCOUNTTYPE')"
      mwlResizeHandle
      [resizeEdges]="{ right: true }"
      >
      <div class="resize-handle-right" mwlResizeHandle
      [resizeEdges]="{ right: true }"></div> Account Type </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.ACCOUNTTYPE}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="ACCOUNTNO">
      <mat-header-cell *matHeaderCellDef mat-sort-header mwlResizable

        (resizeEnd)="onResizeEnd($event, 'ACCOUNTNO')"
        mwlResizeHandle
        [resizeEdges]="{ right: true }"
        >
        <div class="resize-handle-right" mwlResizeHandle
        [resizeEdges]="{ right: true }"></div>
      Account No</mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.ACCOUNTNO}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="ACCOUNTNAME">
      <mat-header-cell *matHeaderCellDef mat-sort-header mwlResizable

        (resizeEnd)="onResizeEnd($event, 'ACCOUNTNAME')"
        mwlResizeHandle
        [resizeEdges]="{ right: true }"
        >
        <div class="resize-handle-right" mwlResizeHandle
        [resizeEdges]="{ right: true }"></div>
      Account Name. </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.ACCOUNTNAME}} </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns;sticky:true"></mat-header-row>
    <mat-row [style.background]="highlightedRows == index? selectedColore : ''" [ngClass]="highlightedRows == index ? 'row-text-colore' : ''" highlightedRows=index *matRowDef="let row let index = index; columns: displayedColumns;" (click)="accountrow(row,index);highlightedRows = index "
    matRipple [@animate]="{value:'*',params:{y:'100%'}}"></mat-row>
  </table> -->
    <table
      mat-table
      (matSortChange)="sortData($event)"
      matSortActive="{{ sortactive }}"
      matSortDirection="{{ sortDirection }}"
      matSortDisableClear
      [dataSource]="FinalList"
      matSort
      multiTemplateDataRows
    >
      <ng-container matColumnDef="DESCRIPTION">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          mwlResizable
          [enableGhostResize]="false"
          (resizeEnd)="onResizeEnd($event, 'DESCRIPTION')"
          [resizeEdges]="{
            bottom: false,
            right: true,
            top: false,
            left: true,
          }"
        >
          <div
            class="resize-handle-right"
            mwlResizeHandle
            [resizeEdges]="{ right: true }"
            (mousedown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
          ></div>
          Description
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.DESCRIPTION }}
        </td>
      </ng-container>
      <ng-container matColumnDef="ACCOUNTTYPE">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          mwlResizable
          [enableGhostResize]="false"
          (resizeEnd)="onResizeEnd($event, 'ACCOUNTTYPE')"
          [resizeEdges]="{
            bottom: false,
            right: true,
            top: false,
            left: true,
          }"
        >
          <div
            class="resize-handle-right"
            mwlResizeHandle
            [resizeEdges]="{ right: true }"
            (mousedown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
          ></div>
          Account Type
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.ACCOUNTTYPE }}
        </td>
      </ng-container>
      <ng-container matColumnDef="ACCOUNTNO">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          mwlResizable
          [enableGhostResize]="false"
          (resizeEnd)="onResizeEnd($event, 'ACCOUNTNO')"
          [resizeEdges]="{
            bottom: false,
            right: true,
            top: false,
            left: true,
          }"
        >
          <div
            class="resize-handle-right"
            mwlResizeHandle
            [resizeEdges]="{ right: true }"
            (mousedown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
          ></div>
          Account No
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.ACCOUNTNO }}
        </td>
      </ng-container>
      <ng-container matColumnDef="ACCOUNTNAME">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          mwlResizable
          [enableGhostResize]="false"
          (resizeEnd)="onResizeEnd($event, 'ACCOUNTNAME')"
          [resizeEdges]="{
            bottom: false,
            right: true,
            top: false,
            left: true,
          }"
        >
          <div
            class="resize-handle-right"
            mwlResizeHandle
            [resizeEdges]="{ right: true }"
            (mousedown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
          ></div>
          Account Name.
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.ACCOUNTNAME }}
        </td>
      </ng-container>
      <ng-container matColumnDef="ACTIVITY">
        <th mat-header-cell *matHeaderCellDef style="max-width: 80px">
          <div class="resize-handle-right" [resizeEdges]="{ right: true }"></div>
        </th>
        <td mat-cell *matCellDef="let element" style="max-width: 80px">
          <div>
            <button
              matIconButton
              (click)="toggleRow(element)"
              class="spend-money-dropdown expand-botton flex items-center border border-black/12 text-black"
            >
              <mat-icon class="items-center justify-center text-2xl">
                {{ element.expanded ? 'keyboard_arrow_up' : 'edit' }}
              </mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let element"
          [attr.colspan]="displayedColumns.length"
          style="margin-bottom: -16px"
        >
          <div
            class="example-element-detail"
            animate.enter="detail-expand-in"
            animate.leave="detail-expand-out"
          >
            <div fxLayout="row" fxLayoutAlign="start center" class="py-4">
              <mat-form-field
                appearance="outline"
                class="example pr-1"
                fxFlex="49"
                subscriptSizing="dynamic"
              >
                <mat-label>Name</mat-label>
                <input readonly [(ngModel)]="accDialoge.Name" name="Name" matInput />
                <mat-icon matSuffix class="secondary-text"></mat-icon>
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                fxFlex="50"
                class="pr-1"
                subscriptSizing="dynamic"
              >
                <mat-label>Acc NO</mat-label>
                <input name="AccNo" [(ngModel)]="accDialoge.AccNo" matInput />
                <mat-icon matSuffix (click)="openAccount(accDialoge.AccType)">
                  <img src="assets/icons/web_app/icon_receipt_o.ico" />
                </mat-icon>
              </mat-form-field>
            </div>
            <mat-dialog-actions class="justify-end!" style="margin-top: 0px">
              <button
                (click)="updateData()"
                class="ng-tns-c142-6 mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary spend-money-updates mat-mdc-button-base"
                matButton="filled"
                cdkFocusInitial
              >
                Save
              </button>
              <button
                fxFlex="20"
                class="btn-add-2 pr-1"
                mat-button
                (click)="cancleData()"
                class="ng-tns-c142-6 mdc-button mat-mdc-button mat-warn mat-mdc-button-base spend-money-deletes"
                cdkFocusInitial
              >
                Cancel
              </button>
              <!-- </div> -->
            </mat-dialog-actions>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        [style.background]="highlightedRows == row.id ? selectedColore : ''"
        [ngClass]="highlightedRows == row.id ? 'row-text-colore' : ''"
        *matRowDef="let row; columns: displayedColumns"
        (click)="accountrow(row, row.id); highlightedRows = row.id"
        class="example-element-row"
        [class.example-expanded-row]="row.expanded"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']; when: isExpandedRow"
        class="example-detail-row"
      ></tr>
    </table>
  </div>
  <mat-paginator
    [pageSizeOptions]="[10, 20, 50, 100]"
    [pageSize]="$safeNavigationMigration(pageSize?.account_page)"
    (page)="onPaginateChange($event)"
    showFirstLastButtons
  ></mat-paginator>
  <!-- <mat-dialog-actions align="end" class="popup_ftr">
        <button mat-raised-button color="accent" class="mat-accent" class="btn_2" (click)="ondialogClick()">Edit</button>
    </mat-dialog-actions> -->
</div>
<hr />
<div>
  <mat-dialog-actions class="popup_ftr justify-end!">
    <button
      id="callApiId"
      class="mainbtn_size"
      matButton="filled"
      [disabled]="isspiner"
      (click)="saveAccount()"
    >
      @if (isspiner) {
        <mat-spinner diameter="24"></mat-spinner>
      }
      Save
    </button>
    <!-- <button class="btn_2" mat-raised-button color="primary" cdkFocusInitial>Don't Save</button> -->
  </mat-dialog-actions>
</div>
